require('typeface-montserrat')



// WEBPACK FOOTER //
// ./src/vendor/typeface-montserrat.js